import React, { Fragment, useEffect } from "react";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import esLocale from "date-fns/locale/es";
import Stack from "@mui/material/Stack";
import Autocomplete from "@mui/material/Autocomplete";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import estilos from "./PanelInformacionPredio.module.css"
import Modal from '@mui/material/Modal';
import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import {
  obtenerTodosLosClientesConDetalleDescuento,
} from "../../../redux/InformacionValidaDucks";
import { obtenerDatosMagueyByIdPredio, actualizarDatosMaguey, } from "../../../redux/DucksUsuarioAgricola/DatosMagueyDucks";
import { obtenerGuiaByIdentificador, obtenerGuiaMaguey, setInitialData, } from "../../../redux/DucksUsuarioAgricola/GuiaMagueyDucks";
import { useState } from "react";
import ModalMensaje from '../ModalMensaje';
import { obtenerTodosDatosPredioDescuento } from "../../../redux/DucksUsuarioAgricola/DatosPredioDucks";
const styleModal = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};
import moment from "moment";
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from "../../../redux/AppDucks";
import { obtenerAllClientesDescuentoPredio } from "../../../redux/DucksUsuarioAgricola/DescuentoPredioDucks";
const Descuento_Predio = () => {
  const dispatch = useDispatch();
  const idPredio = (input, len) => {
    const number = parseInt(input, 10);
    const paddedNumber = number.toString().padStart(len, "0");
    return paddedNumber;
  };
  const [fechaDescuento, setFechaDescuento] = React.useState(new Date());

  const [modal, setModal] = React.useState(false)
  const [textoModal, setTextoModal] = React.useState('')
  const [tituloModal, setTituloModal] = React.useState('')
  const resetValores = (objectProducto) => {
    setModal(objectProducto.validacion)
  }

  const [predio, setPredio] = React.useState({
    id: null,
    num_guia: null,
    num_predio: null,
    nombre_predio: null,
    num_cliente: null,
    nombre_cliente: null,
    iddatospredio: null,
  });
  let dataPredios = useSelector((store) => store.DatosPredioApi?.dataDescuento?.data);

  //let dataAsociados = [];



  //dataPredios = useSelector((store) => store.DatosPredioApi?.data?.data);
  //dataAsociados = useSelector((store) => store.InformacionValidaApi?.dataDescuento?.data);
  let dataAsociados = useSelector((store) => store.DescuentoPredio?.clientesDescuento);
  console.log('los datos de dataAsociados ', dataAsociados)
  const dataEspecies = useSelector((store) => store.CatalogoMagueyApi?.data?.data);

  let datosMaguey = useSelector((store) => store.DatosMagueyApi.data.data);

  const [datosMagueyData, setDatosMagueyData] = React.useState(datosMaguey)
  let dataIdentificador = useSelector((store) => store.GuiaMagueyApi.data.data);
  const [guias, setGuias] = React.useState([])
  //let  = useSelector((store) => store.GuiaMagueyApi.guias);

  let dataNumGuia = useSelector((store) => store.GuiaMagueyApi.data.data);

  React.useEffect(async () => {
    //await dispatch(obtenerTodosLosClientesConDetalleDescuento())
    await dispatch(obtenerAllClientesDescuentoPredio())

  }, []);

  useEffect(() => {
    setDatosMagueyData(datosMaguey)

  }, [datosMaguey]);

  React.useEffect(async () => {
    const resultado = await dispatch(obtenerGuiaMaguey())
    setGuias(resultado.payload)
  }, [])

  React.useEffect(async () => {
    await dispatch(actualizarLoadingApp_true())
    dispatch(obtenerTodosDatosPredioDescuento())
    await dispatch(actualizarLoadingApp_false())
  }, []);

  const [guia, setGuia] = useState({
    identificador: null,
  })

  const [asociado, setAsociado] = React.useState({
    idcliente: null,
    num_Asociado: null,
    numerosocio: null,
    datospredio: [],
  });

  const [receptor, setReceptor] = React.useState({
    idcliente: null,
    num_Asociado: null,
    numerosocio: null,
    datospredio: [],
  });
  const [numAsociado, setNumAsociado] = React.useState("");
  const [numReceptor, setNumReceptor] = React.useState("");
  console.log('los datos de num receptor ', numReceptor)
  const [numGuia, setNumGuia] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [openGuia, setOpenGuia] = React.useState(false);
  const [openReceptor, setOpenReceptor] = React.useState(false);
  const [numPredioA, setNumPredioA] = React.useState("");
  const [predioA, setPredioA] = React.useState({
    iddatospredio: null,
    superficiehectarea: null,
    longitudoeste: null,
    latitudnorte: null,
    especie: null,
    edad: null,
    fecharegistro: null,
    estado: null,
    municipio: null,
    localidad: null,
    tenenciatierra: null,
    usufructotierra: null,
    representantecampo: null,
    espropietario: null,
    nombrecompletopropietario: null,
    idcliente: null,
    nombrepredio: null,
    nombreusuario: null,
    tapada: null,
    kgvariedad: null,
    cliente: null,
    guias: null,
    datosMaguey: null
  });

  const handlerSeleccion = (value) => {
    if (value === null) {
      setNoGuia("");
    }
    setAsociado(value);
  };

  const handlerSeleccionPredioA = async (value) => {
    if (value === null) {
      setNumPredioA("");
    }
    setPredioA(value);
    setGuias(value?.guias)
    if (numGuia == '') {
      let { ...aOrdenar } = value?.datosmaguey
      const miArreglo = Object.values(aOrdenar);
      let ordenado = miArreglo.sort((a, b) => a.iddatosmaguey - b.iddatosmaguey);
      setDatosMagueyData(ordenado)
    }
  };

  const handlerSeleccionGuia = async (value) => {
    if (value === null) {
      setNumGuia("");
    }
    setGuia({ identificador: value.identificador });
    if (predioA.iddatospredio == null || predioA.iddatospredio != value.iddatospredio) {
      setPredioA(value.datospredio)
      setNumPredioA(idPredio(value?.iddatospredio + '', 5))

      let { ...aOrdenar } = value?.datospredio?.datosmaguey
      const miArreglo = Object.values(aOrdenar);
      let ordenado = miArreglo.sort((a, b) => a.iddatosmaguey - b.iddatosmaguey);
      setDatosMagueyData(ordenado)

      let filtroGuias = guias.filter(anexo => anexo.iddatospredio == value.iddatospredio)
      setGuias(filtroGuias)
    }
  };

  const handlerSeleccionReceptor = (value) => {
    if (value === null) {
      setNumReceptor("");
    }
    setReceptor(value);
  };

  const styleNormal = {
    "& legend": { display: "none" },
    "& fieldset": { top: 0 },
    background: "white",
  };

  const descriptionElementRef = React.useRef(null);
  const [openModal, setOpenModal] = React.useState(false);

  const handleClose = () => {
    setOpenModal(false);
  };


  const [noGuia, setNoGuia] = React.useState("");
  const [nuevaExistencia, setNuevaExistencia] = React.useState(0);

  const [descuento, setDescuento] = React.useState(0);

  const [nombreTapada, setNombreTapada] = React.useState("");
  const [nombreInspector, setNombreInspector] = React.useState("");


  const [isDisabled, setIsDisabled] = React.useState(true);

  const [dataTable, setDataTable] = React.useState([]);

  const [maguey, setMaguey] = React.useState({
    id: null,
    num_guia: null,
    edad: null,
    existencia: null,
    especie: null,
  });

  const [dataMagueySelect, setDataMagueySelect] = React.useState([]);

  const style = {
    "& legend": { display: "none" },
    "& fieldset": { top: 0 },
    background: "#ddd",
    cursor: "not-allowed",
    pointerEvents: "none",
  };



  const handlerDescuento = (e) => {
    setDescuento(e);
    maguey && e > 0
      ? setNuevaExistencia(maguey.numeroplantas - e)
      : setNuevaExistencia(maguey.numeroplantas);
  };

  const handlerOpenModal = async () => {
    if (predioA?.iddatospredio !== null) {
      if (guia?.identificador !== null) {
        if (nombreTapada.trim()) {
          if (nombreInspector.trim()) {
            setOpenModal(true);
          } else {
            alert("Ingresa inspector");
          }
        } else {
          alert("Ingresa Tapada");
        }
      }
    } else {
      alert("Ingresa Num Guia");
    }
  };

  const guardarDescuento = async () => {
    await dispatch(actualizarLoadingApp_true())
    let dataMaguey = datosMagueyData.filter(item => item.hasOwnProperty('descuento') && item.descuento > 0).map(item => {
      let descuento = 0;
      let kgvariedad = 0;
      const fechaHoy = moment().format('YYYY-MM-DD')
      descuento = Number(item.descuento);
      item.hasOwnProperty('kgvariedad') ? kgvariedad = item.kgvariedad : 0
      return {
        iddatosmaguey: item.iddatosmaguey,
        numeroplantas: item.numeroplantas - descuento,
        tapada: nombreTapada,
        inspector: nombreInspector,
        fechadescuento: fechaDescuento,
        identificador: guia.identificador,
        kgvariedad: kgvariedad !== "" ? Number(kgvariedad) : 0,
        receptor: receptor !== null && receptor.numerosocio !== null ? receptor.numerosocio : predioA?.cliente?.numerosocio,
        descuento: descuento,
        identificador: numGuia,

      }
    })
    try {
      let resp = await dispatch(actualizarDatosMaguey({ data: dataMaguey }));
      await dispatch(obtenerTodosDatosPredioDescuento())
      /*if (resp.data?.data !== null) {
        let obtener = await dispatch(obtenerTodosDatosPredio())
        const resultado = await dispatch(obtenerGuiaMaguey())
        setGuias(resultado.payload)
        setDataPredios(obtener?.payload?.data?.data)
      }
      limpiarValores()
      setOpenModal(false);
      setOpenModalVerificar(false)*/
    } catch (rejectedValueOrSerializedError) {
      alert("Intentalo de nuevo");
      setOpenModal(false);
    }
    await dispatch(actualizarLoadingApp_false())
    window.location.reload(true)


  };
  const limpiarValores = async () => {
    setPredioA({
      iddatospredio: null,
      superficiehectarea: null,
      longitudoeste: null,
      latitudnorte: null,
      especie: null,
      edad: null,
      fecharegistro: null,
      estado: null,
      municipio: null,
      localidad: null,
      tenenciatierra: null,
      usufructotierra: null,
      representantecampo: null,
      espropietario: null,
      nombrecompletopropietario: null,
      idcliente: null,
      nombrepredio: null,
      nombreusuario: null,
      tapada: null,
      kgvariedad: null,
      cliente: null,
      guias: null,
      datosMaguey: null
    })
    setGuia({
      identificador: null,
    })
    setNumPredioA(null)
    setNumGuia(null)
    setNombreInspector("")
    setNombreTapada("")
    setNumReceptor(null)
    setReceptor(null)
    /*const resultado = await dispatch(obtenerGuiaMaguey())
    setGuias(resultado.payload)*/
  }
  const cancelar = async () => {
    window.location.reload(true)
  }
  const body = (
    <>
      <div className="bg-light rounded  ">
        <h3 className="text-center">Datos del Maguey</h3>
        <div className="row">
          <div className="col-6">
            <label className="form-label">Existencia:</label>
            <TextField
              variant="outlined"
              disabled
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              size="small"
              style={{ background: "white" }}
              fullWidth
              name="nombreparaje"
              value={
                maguey !== null && maguey.numeroplantas !== null
                  ? maguey.numeroplantas
                  : ""
              }
            />
          </div>
          <div className="col-6">
            <label className="form-label">Descuento:</label>
            <TextField
              fullWidth
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              type="number"
              inputProps={{
                inputMode: "numeric",
                min: 0,
                max:
                  maguey !== null && maguey.numeroplantas > 0
                    ? maguey.numeroplantas
                    : 0,
              }}
              size="small"
              defaultValue={0}
              onChange={(e) => handlerDescuento(e.target.value)}
            />
          </div>
          <div className="col-6">
            <label className="form-label">Nueva Existencia:</label>
            <TextField
              disabled
              fullWidth
              sx={style}
              type="number"
              inputProps={{
                inputMode: "numeric",
                min: 0,
              }}
              size="small"
              value={
                maguey !== null &&
                  (maguey.numeroplantas !== undefined ||
                    maguey.numeroplantas !== null)
                  ? nuevaExistencia
                  : ""
              }
            />
          </div>
        </div>
      </div>
    </>
  );

  const [openModalVerificar, setOpenModalVerificar] = React.useState(false);
  const [titleModal, setTitleModal] = React.useState('');
  const [bodyModal, setBodyModal] = React.useState('')
  const [accion, setAccion] = React.useState('')
  const [dataModal, setDataModal] = React.useState('')

  const handleOpenModal = (data) => {

    let dataMaguey = datosMagueyData.filter(item => item.hasOwnProperty('descuento') && item.descuento > 0).map(item => {
      let descuento = 0;
      descuento = Number(item.descuento);
      let numeroplantas = item.numeroplantas - descuento
      if (numeroplantas > 0) return true
      else return false
    })
    if (guia?.identificador !== null) {
      if (nombreTapada.trim()) {
        if (nombreInspector.trim()) {
          if (numReceptor != null && numReceptor != '') {
            let filtroNegativo = dataMaguey?.filter(anexo => anexo == false)
            if (filtroNegativo.length == 0) {
              setTitleModal(data.title)
              setBodyModal(data.body)
              setAccion(data.accion)
              setOpenModalVerificar(true)
            } else {
              setTextoModal('El descuento en los magueyes excede el número de plantas existentes')
              setTituloModal('Campos Obligatorios')
              setModal(true)
            }
          } else {
            setTextoModal('Falta ingresar el receptor')
            setTituloModal('Campos Obligatorios')
            setModal(true)
          }
        } else {
          setTextoModal('Falta ingresar el inspector')
          setTituloModal('Campos Obligatorios')
          setModal(true)
        }
      } else {
        setTextoModal('Falta ingresar la tapada')
        setTituloModal('Campos Obligatorios')
        setModal(true)
      }

    } else {
      setTextoModal('Falta ingresar el número de guia')
      setTituloModal('Campos Obligatorios')
      setModal(true)
    }

  }
  const handleCloseModal = () => {
    setTitleModal('')
    setBodyModal('')
    setAccion('')
    setOpenModalVerificar(false)
    //window.location.reload(true)
  }
  const modalComponent = () => {
    return (
      <div>
        <Modal open={openModalVerificar} onClose={handleCloseModal}
          aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" >
          <Box sx={styleModal}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              <center className="text-danger">{titleModal}</center>
            </Typography>
            <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
              <center >{bodyModal}</center> <br /> <center><strong>¿Desea continuar?</strong></center>
            </Typography>
            <br />
            <div className='row'>
              <div className="col-5">
                <button className='btn btn-success' onClick={() => {
                  switch (accion) {
                    case 'GuardarDescuento':
                      guardarDescuento()
                      break;
                    default:
                      break;
                  }
                }}>CONTINUAR</button>
              </div> <div className="col-2"></div>
              <div className="col-5">
                <button className='btn btn-dark' onClick={() => handleCloseModal()} >CANCELAR</button>
              </div>
            </div>
          </Box>
        </Modal>
      </div>
    )
  }

  const botonGuardar = async () => {
    handleOpenModal({
      title: `¡Advertencia!`,
      body: `Estas seguro de aplicar el descuento?`,
      accion: 'GuardarDescuento'
    })

  }

  return (
    <Fragment>
      <br />

      <div className="container">
        <h2 className="text-center">Descuentos por Predio</h2>
        <div className="bg-light p-5 rounded ms-5">
          <div className="row">
            <div style={{ textAlign: 'right' }}>

            </div>
            <div className="col-12">
              <h3 className={`${estilos.labelEspecial} text-center `}>Datos del Predio</h3>

              <div className="pt-2">
                <div className="row g-3">
                  <div className="col-sm-6">
                    <label className="form-label"></label>
                    <label className="form-label">No. Predio "A":</label>
                    <Autocomplete
                      freeSolo
                      open={open}
                      inputValue={numPredioA !== null && numPredioA !== undefined ? numPredioA : ""}

                      onOpen={() => {
                        setOpen(true);
                      }}
                      onClose={() => setOpen(false)}
                      onInputChange={(e, value) => {
                        setNumPredioA(value);

                        /*if (!value) {
                          setOpen(false);
                        }*/
                      }}
                      onChange={(event, value) => {
                        handlerSeleccionPredioA(value);
                      }}
                      options={dataPredios ? dataPredios : []}

                      getOptionLabel={(opcion) =>
                        opcion ? (String(opcion.iddatospredio).length == 1 ? "0000" : String(opcion.iddatospredio).length == 2 ? "000" : String(opcion.iddatospredio).length == 3 ? "00" : String(opcion.iddatospredio).length == 4 ? "0" : String(opcion.iddatospredio).length == 5 ? "" : "") + opcion.iddatospredio : ""
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          size="small"
                          style={{ background: "white" }}
                          fullWidth
                          onKeyDown={e => { !open && e.key === "Enter" && e.stopPropagation(); }}
                        />
                      )}
                    />
                  </div>
                  <div className="col-sm-6">
                    <label className="form-label"></label>
                    <label className="form-label">No. Guía:</label>
                    <Autocomplete
                      freeSolo
                      open={openGuia}
                      onOpen={() => {
                        setOpenGuia(true);
                      }}
                      onClose={() => setOpenGuia(false)}
                      inputValue={numGuia ? numGuia : ""}
                      onInputChange={(e, value) => {
                        setNumGuia(value);

                        if (!value) {
                          setOpenGuia(false);
                        }
                      }}
                      onChange={(event, value) => {
                        handlerSeleccionGuia(value);
                      }}
                      //options={predioA?.guias ? predioA?.guias?.filter(e => e.esactiva) : []}
                      options={guias ? guias?.filter(e => e.esactiva) : []}

                      defaultValue=""
                      getOptionLabel={(opcion) =>
                        opcion ? opcion.identificador.toUpperCase() + "" : ""
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          size="small"
                          style={{ background: "white" }}
                          fullWidth
                          onKeyDown={e => { !openGuia && e.key === "Enter" && e.stopPropagation(); }}
                        />
                      )}
                    />
                  </div>
                  <div className="col-4">
                    <label className="form-label">Numero de Cliente:</label>
                    <TextField
                      disabled
                      fullWidth
                      sx={style}
                      size="small"
                      value={predioA?.cliente?.numerosocio}
                    />
                  </div>
                  <div className="col-4">
                    <label className="form-label">Nombre Cliente:</label>
                    <TextField
                      disabled
                      fullWidth
                      sx={style}
                      size="small"
                      value={
                        predioA?.cliente?.nombrerazonsocial
                          ? predioA?.cliente?.nombrerazonsocial
                          : ""
                      }
                    />
                  </div>
                  <div className="col-4">
                    <label className="form-label">Nombre del Predio:</label>
                    <TextField
                      disabled
                      fullWidth
                      sx={style}
                      size="small"
                      value={predioA?.nombrepredio ? predioA?.nombrepredio : ""}
                    />
                  </div>
                  <div className="col-sm-6">
                    <label className="form-label">Tapada:</label>
                    <TextField
                      fullWidth
                      sx={styleNormal}
                      size="small"
                      value={nombreTapada}
                      onChange={(e) => setNombreTapada(e.target.value)}
                    />
                  </div>
                  <div className="col-sm-6">
                    <label className="form-label">Inspector:</label>
                    <TextField
                      fullWidth
                      sx={styleNormal}
                      size="small"
                      value={nombreInspector}
                      onChange={(e) => setNombreInspector(e.target.value)}
                    />
                  </div>

                  <div className="col-6">
                    <label className="form-label">Fecha Descuento:</label>
                    <LocalizationProvider
                      dateAdapter={AdapterDateFns}
                      locale={esLocale}
                    >
                      <DatePicker
                        value={fechaDescuento}
                        fullWidth
                        disableFuture
                        onChange={(newValue) => {
                          setFechaDescuento(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            sx={styleNormal}
                            size="small"
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </div>
                  <div className="col-sm-6">
                    <label className="form-label">Receptor Guía:</label>
                    <Autocomplete
                      freeSolo
                      open={openReceptor}
                      onOpen={() => {
                        if (numReceptor) {
                          setOpenReceptor(true);
                        }
                      }}
                      onClose={() => setOpenReceptor(false)}
                      inputValue={numReceptor ? numReceptor : ""}
                      onInputChange={(e, value) => {
                        setNumReceptor(value);

                        if (!value) {
                          setOpenReceptor(false);
                        }
                      }}
                      onChange={(event, value = "") => {
                        handlerSeleccionReceptor(value);
                      }}
                      options={dataAsociados ? dataAsociados : []}

                      getOptionLabel={(opcion) =>
                        opcion ? `${opcion.numerosocio} - ${opcion.nombrerazonsocial}` : ""
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          size="small"
                          style={{ background: "white" }}
                          fullWidth
                          onKeyDown={e => { !openReceptor && e.key === "Enter" && e.stopPropagation(); }}
                        />
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 pt-4">
            <Paper sx={{ width: "100%" }}>
              <TableContainer sx={{ maxHeight: 600 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Especie</TableCell>
                      <TableCell>Edad</TableCell>
                      <TableCell>Numero de plantas</TableCell>
                      <TableCell>Descuento</TableCell>
                      <TableCell>Nuevo valor</TableCell>
                      <TableCell>Kg por Variedad</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(predioA !== null && predioA !== undefined) &&
                      predioA?.iddatospredio !== null &&
                      datosMagueyData?.map((item, i) => (
                        <TableRow
                          key={item?.iddatosmaguey}
                          sx={
                            item?.edad !== null && item?.edad >= 5 ?
                              {
                                border: 0,
                              }
                              :
                              item?.edad !== null && item?.edad < 5 ?
                                { border: "2px solid red" }
                                : ''
                          }
                        >
                          <TableCell>
                            {item.catalogomaguey.nombrecomun +
                              "" +
                              " - " +
                              item.catalogomaguey?.catalogomagueynombrecientifico?.nombrecientifico}
                          </TableCell>
                          <TableCell>{item.edad}</TableCell>
                          <TableCell>{item.numeroplantas}</TableCell>
                          <TableCell>
                            <div key={i} className="column">
                              <input
                                ref={this}
                                style={{ width: 60 }}
                                type="number"
                                min={0}
                                max={item.numeroplantas}
                                disabled={Number(item.edad) < 5 ? true : false}
                                onChange={(event) => {
                                  setDatosMagueyData(
                                    datosMagueyData.map((obj, p) => {
                                      if (i === p) {
                                        return {
                                          ...obj,
                                          descuento: event.target.value,
                                        };
                                      }
                                      return obj;
                                    })
                                  );
                                }}
                              />
                            </div>
                          </TableCell>
                          <TableCell
                            sx={() => {
                              if (
                                item.descuento !== undefined &&
                                item.descuento !== "" &&
                                item.descuento !== "0"
                              ) {
                                return { background: "  #fce7e7 " };
                              }
                            }}
                          >
                            {item.numeroplantas -
                              Number(item.descuento ? item.descuento : 0)}
                          </TableCell>
                          <TableCell>
                            <div key={i} className="column">
                              <input
                                ref={this}
                                required
                                disabled={Number(item.edad) < 5 ? true : false}
                                style={{ width: 60 }}
                                type="number"
                                min={0}
                                onChange={(event) => {
                                  setDatosMagueyData(
                                    datosMagueyData.map((obj, p) => {
                                      if (i === p) {
                                        return {
                                          ...obj,
                                          kgvariedad: event.target.value,
                                        };
                                      }
                                      return obj;
                                    })
                                  );
                                }}
                              />
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
            <br />
            <div className="col-sm-12">
              <label className="form-label">
                <br />
              </label>
              <div className="row text-center">
                <div className="col">
                  <button
                    /* disabled={
                       predioA === null ||
                       guia === null ||
                       predioA?.iddatospredio === null //||
                       //guia?.identificador === null
                     }*/
                    disabled={numPredioA == null || numPredioA == ''}
                    style={{ borderRadius: '6px', padding: '10px' }} className='btn-success btn-lg'
                    onClick={() => botonGuardar()} > Aplicar </button>
                </div>

                <div className="col">
                  <button style={{ borderRadius: '6px', padding: '10px' }} className='btn-danger btn-lg' onClick={e => cancelar()}>Cancelar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modal && <ModalMensaje texto={textoModal} titulo={tituloModal} api={{ resetValores }}></ModalMensaje>}
      {modalComponent()}
    </Fragment>
  );
};
export default Descuento_Predio;
